import { map } from 'rxjs/operators';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-notification-pwa-update',
  templateUrl: './notification-pwa-update.component.html',
  styleUrls: ['./notification-pwa-update.component.scss']
})
export class NotificationPwaUpdateComponent implements OnInit {

  showUpdateNotification = false;
  subscription: Subscription;

  constructor(
    private swUpdate: SwUpdate,
    private location: Location,
  ) { }

  ngOnInit() {
    if (this.swUpdate.isEnabled) {
      //  First update check
      this.swUpdate.checkForUpdate();

      // Periodic update check every 5 min
      setInterval(() => {
        this.swUpdate.checkForUpdate();
      }, 5000);

      // Listen for update available events
      this.subscription = this.swUpdate.versionUpdates.pipe(
        map(event => {
          if (event.type === "VERSION_READY") {
            // Disable update popup for selected views (e.g. session) 
            const url = this.location.path();
            // const isDisabledForUrl = url.includes('/map/') || url.includes('/queue/') || url.includes('/session/');
            const isDisabledForUrl = url.includes('/session/');

            if (!isDisabledForUrl) {
              this.showUpdateNotification = true;
            }
          }
        })).subscribe();

    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onUpdate() {
    window.location.reload();
  }

  onCloseNotification() {
    this.showUpdateNotification = false;
  }

}